import React from 'react';

const SvgLr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LR_svg__b" fill="#fff">
        <use xlinkHref="#LR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M13.333 0H28v2.667H13.333V0zm0 5.333H28V8H13.333V5.333zm0 5.334H28v2.666H13.333v-2.666zM0 16h28v2.667H0V16z"
        fill="#E1244A"
        mask="url(#LR_svg__b)"
      />
      <path fill="#0C3F8E" mask="url(#LR_svg__b)" d="M0 0h13.333v13.333H0z" />
      <path
        fill="#FFF"
        mask="url(#LR_svg__b)"
        d="M6.667 8.227L4.316 9.903l.867-2.754-2.32-1.718 2.887-.026.917-2.738.917 2.738 2.887.026-2.32 1.718.867 2.754z"
      />
    </g>
  </svg>
);

export default SvgLr;
